/* global BaseUrl */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import { getNetworkBranding, urlIsExternal } from 'helpers/ContentHelper';
import style from './Error404.css';

const {
  notFoundPage_button: button,
  notFoundPage_header: header,
  notFoundPage_message: message,
} = window.Language;

const Error404 = (props = {}) => {
  const { breakpoint, branding } = props;
  const notFoundPage = _.get(window, 'ExternalConfig.notFoundPage', {});
  const logo = _.get(notFoundPage, 'logo', null);
  const colors = _.get(notFoundPage, 'color', []);
  const imageDesktop = _.get(notFoundPage, 'background.desktop', null);
  const imageMobile = _.get(notFoundPage, 'background.mobile.portrait', null);
  const homePageUrl = _.get(notFoundPage, 'url', null);
  const currentBranding = branding || getNetworkBranding();
  const wrapper = classNames([style.screen, style[currentBranding]]);
  const images = {
    [SITE_PLATFORM_WEB_LARGE]: imageDesktop,
    [SITE_PLATFORM_WEB]: imageDesktop,
    [SITE_PLATFORM_TABLET]: imageMobile,
    [SITE_PLATFORM_MOBILE]: imageMobile,
  };
  const image = _.get(images, breakpoint, null);
  const isColorBackground = colors && colors.length > 0;
  const isImageBackground = !isColorBackground && image;

  const renderCharacter = () => {
    if (isColorBackground || (isImageBackground && logo)) {
      const character = logo || image;
      return (
        <div className={classNames([style.character, logo && style.logo])}>
          <img src={character} alt="Background character" />
        </div>
      );
    }
    return null;
  };

  const renderBackground = () => {
    if (isColorBackground) {
      const gradientBG =
        colors.length === 2 ? `radial-gradient(circle at 50% 0, ${colors.join(', ')})` : null;
      const flatBG = colors.length === 1 ? colors[0] : null;
      if (!gradientBG && !flatBG) return null;

      const background = flatBG || gradientBG;
      return <div className={style.background} style={{ background }} />;
    }
    if (isImageBackground) {
      const backgroundStyle = { backgroundImage: `url(${image})` };
      return <div className={style.background} style={backgroundStyle} />;
    }
    return null;
  };

  const renderCTAButton = () => {
    const buttonClass = classNames([style.button, logo && style.logoButton]);
    return (
      <a href={homePageUrl === '/' ? BaseUrl : homePageUrl} className={buttonClass}>
        {button}
      </a>
    );
  };

  const renderMessage = () => {
    const words = message.split(' ');
    const leftWords = [];
    const rightWords = [];
    let linkIndex;
    let messageLink;
    words.forEach((word, index) => {
      if (urlIsExternal(word)) {
        linkIndex = index;
        messageLink = (
          <a className={style.messageLink} href={`https://${word}`}>
            {word}
          </a>
        );
        words.slice(index, 1);
      } else if (!linkIndex) {
        leftWords.push(word);
      } else if (linkIndex) {
        rightWords.push(word);
      }
    });
    if (messageLink) {
      return (
        <div className={style.message}>
          {leftWords.join(' ')} {messageLink} {rightWords.join(' ')}
        </div>
      );
    }
    return <div className={style.message}>{message}</div>;
  };

  return (
    <div className={wrapper}>
      {renderBackground()}
      <div className={style.info}>
        {renderCharacter()}
        <div className={style.innerBackground} />
        <div className={style.header}>{header}</div>
        {renderMessage()}
        {renderCTAButton()}
      </div>
    </div>
  );
};

Error404.defaultProps = {
  breakpoint: SITE_PLATFORM_WEB,
  branding: null,
};

Error404.propTypes = {
  breakpoint: PropTypes.string,
  branding: PropTypes.string,
};

export default Error404;
